import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { RacingTab } from './RacingTab/RacingTab';
import TwoParticipantsSportsTab from './TwoParticipantsSportsTab';
import { CompetitionsTabNew } from './CompetitionsTab/CompetitionsTabNew';
import { OutrightBet } from './OutrightTab/OutrightBet';
import { TabsContent } from './EventsTab.style';

const outrightSports = ['golf', 'motorsport', 'cycling', 'olympics', 'pool', 'bowls', 'tvspecials'];

interface EventsTabContentPropsType {
    sportId: string;
    userId: number;
}

export const EventsTabContent = observer('EventsTabContent', (propsIn: EventsTabContentPropsType) => {
    const { sportId, userId } = propsIn;
    const renderContent = (): JSX.Element => {
        if (sportId === 'horseracing' || sportId === 'greyhoundracing' || sportId === 'internationalhorseracing') {
            return (
                <RacingTab
                    userId={userId}
                    sport={sportId}
                    key={sportId}
                />
            );
        }

        if (sportId === 'football') {
            return (
                <TwoParticipantsSportsTab
                    userId={userId}
                    sport={sportId}
                    key={sportId}
                />
            );
        }

        if (outrightSports.includes(sportId)) {
            return (
                <div>
                    <OutrightBet
                        sport={sportId}
                        userId={userId}
                        key={sportId}
                    />
                </div>
            );
        }

        return (
            <div>
                <CompetitionsTabNew
                    sport={sportId}
                    userId={userId}
                    key={sportId}
                />
            </div>
        );
    };

    return <TabsContent>{renderContent()}</TabsContent>;
});
